/* ============================================================
   Boost Blenz — FAQ Help Center AI assistant (production)
   Upload as: assets/bb-faq-ai.js  (loaded by sections/bb-faq-hero.liquid)

   WHAT THIS DOES
   - Reads config from #bbAskForm data-* attributes (set in Theme Editor).
   - Builds a knowledge base (KB) from the rendered FAQ list on the page.
   - On submit:
       1) tries an INSTANT answer from the page (exact/close match) — no API call;
       2) otherwise POSTs { question, kb } to your AI endpoint (a tiny proxy you
          deploy — see workers/bb-faq-ai/). The proxy returns
          { canAnswer:boolean, answer:string, sources:number[] }.
   - If the AI can't answer (or no endpoint / network fails) it offers a human
     handoff: an inline form that posts to your theme's native /contact form.

   The page works fully WITHOUT this script: every answer is in the DOM, the
   browse list + category filters are server-rendered, and search engines read
   the FAQPage schema. This file is progressive enhancement.
   ============================================================ */
(function () {
  var form = document.getElementById('bbAskForm');
  var ai = document.getElementById('bbAi');
  if (!form || !ai || form.dataset.bound === '1') return;
  form.dataset.bound = '1';

  var input = document.getElementById('bbfaqSearch');
  var clearBtn = document.getElementById('bbfaqClear');
  var pop = document.getElementById('bbPop');

  // ---- config from the section (Theme Editor) ----
  var CFG = {
    enabled: form.getAttribute('data-ai-enabled') !== 'false',
    endpoint: (form.getAttribute('data-ai-endpoint') || '').trim(),
    name: form.getAttribute('data-assistant-name') || 'Boost Blenz Assistant',
    email: form.getAttribute('data-support-email') || 'support@boostblenz.com',
    contactAction: form.getAttribute('data-contact-action') || '/contact#contact_form'
  };

  // ---- Build the approved knowledge base from the rendered FAQ list ----
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('#bbfaq .fq-item'));
  var KB = faqItems.map(function (it, i) {
    it.setAttribute('data-faqid', String(i));
    var qEl = it.querySelector('.fq-q');
    var aEl = it.querySelector('.fq-a');
    return {
      id: i,
      q: qEl ? qEl.textContent.trim() : '',
      a: aEl ? aEl.textContent.replace(/\s+/g, ' ').trim() : '',
      html: aEl ? aEl.innerHTML : '',
      el: it
    };
  });

  var currentQ = '';
  var lastRender = null; // restore after cancelling the rep form

  // ---- helpers ----
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function bold(s) { return s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>'); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function fmt(text) {
    var lines = String(text).split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    var html = '', inList = false;
    lines.forEach(function (l) {
      if (/^[-•]\s+/.test(l)) {
        if (!inList) { html += '<ul>'; inList = true; }
        html += '<li>' + bold(esc(l.replace(/^[-•]\s+/, ''))) + '</li>';
      } else {
        if (inList) { html += '</ul>'; inList = false; }
        html += '<p>' + bold(esc(l)) + '</p>';
      }
    });
    if (inList) { html += '</ul>'; }
    return html;
  }
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  function chips(ids) {
    var valid = (ids || []).filter(function (i) { return KB[i]; });
    if (!valid.length) return '';
    return '<div class="fq-ai-sources"><p class="cap">Based on these help-center answers</p><div class="fq-ai-chips">' +
      valid.map(function (i) { return '<button class="fq-ai-chip" type="button" data-jump="' + i + '">' + ARROW + '<span>' + esc(KB[i].q) + '</span></button>'; }).join('') +
      '</div></div>';
  }
  function show(html, cls) {
    ai.hidden = false;
    ai.className = 'fq-ai' + (cls ? ' ' + cls : '');
    ai.innerHTML = html;
  }

  // ---- renders ----
  function renderThinking(q) {
    show(
      '<div class="fq-ai-head"><span class="fq-ai-id"><span class="fq-ai-dot"></span><span class="lbl">' + esc(CFG.name) + '</span></span></div>' +
      '<div class="fq-ai-body"><div class="fq-ai-q">' + esc(q) + '</div>' +
      '<div class="fq-ai-thinking"><span class="fq-ai-dots"><i></i><i></i><i></i></span> Reading our help center…</div></div>'
    );
  }

  function repBtn() {
    return '<button class="fq-ai-rep" type="button" data-rep>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>' +
      'Message our team</button>';
  }

  function renderAnswer(q, answerHTML, ids, note) {
    var html =
      '<div class="fq-ai-head"><span class="fq-ai-id"><span class="fq-ai-dot"></span><span class="lbl">' + esc(CFG.name) + '</span></span>' +
      '<span class="fq-ai-src-note">' + esc(note || 'Answered from our Help Center') + '</span></div>' +
      '<div class="fq-ai-body"><div class="fq-ai-q">' + esc(q) + '</div>' +
      '<div class="fq-ai-a">' + answerHTML + '</div>' + chips(ids) + '</div>' +
      '<div class="fq-ai-foot"><span class="msg">Not quite what you needed? <strong>A real person can help.</strong></span>' + repBtn() + '</div>';
    show(html);
    lastRender = function () { show(html); };
  }

  function renderHandoff(q) {
    var html =
      '<div class="fq-ai-head"><span class="fq-ai-id"><span class="fq-ai-dot"></span><span class="lbl">' + esc(CFG.name) + '</span></span>' +
      '<span class="fq-ai-src-note">Best answered by a person</span></div>' +
      '<div class="fq-ai-body"><div class="fq-ai-q">' + esc(q) + '</div>' +
      '<div class="fq-ai-a"><p>I want to make sure you get this exactly right, and it’s not something our help center fully covers yet. Our Colorado team can answer this personally — usually within one business day.</p></div></div>' +
      '<div class="fq-ai-foot"><span class="msg"><strong>Send your question</strong> and we’ll get right back to you.</span>' + repBtn() + '</div>';
    show(html, 'fq-ai--handoff');
    lastRender = function () { show(html, 'fq-ai--handoff'); };
  }

  function renderRepForm(q) {
    var html =
      '<div class="fq-ai-head"><span class="fq-ai-id"><span class="fq-ai-dot"></span><span class="lbl">Message Our Team</span></span>' +
      '<span class="fq-ai-src-note">Replies within 1 business day</span></div>' +
      '<form class="fq-rep-form" id="bbRepForm">' +
        '<div class="row">' +
          '<div class="fq-rep-field"><label for="rfName">Your name</label><input id="rfName" name="contact[name]" type="text" required></div>' +
          '<div class="fq-rep-field"><label for="rfEmail">Email</label><input id="rfEmail" name="contact[email]" type="email" required></div>' +
        '</div>' +
        '<div class="fq-rep-field"><label for="rfMsg">Your question</label><textarea id="rfMsg" name="contact[body]" required>' + esc(q) + '</textarea></div>' +
        '<div class="fq-rep-actions"><button class="fq-rep-send" type="submit">Send to our team</button>' +
        '<button class="fq-rep-cancel" type="button" data-cancel>Cancel</button></div>' +
        '<p class="fq-rep-note">Goes straight to ' + esc(CFG.email) + ' — no app, no account needed.</p>' +
      '</form>';
    show(html);
    var f = document.getElementById('bbRepForm');
    var nameEl = document.getElementById('rfName');
    if (nameEl) { nameEl.focus(); }
    f.addEventListener('submit', function (e) { e.preventDefault(); submitRep(f, q); });
  }

  function renderSent(q) {
    show(
      '<div class="fq-sent"><span class="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
      '<h4>Message Sent</h4><p>Thanks — our team will reply within one business day. Keep an eye on your inbox.</p></div>'
    );
    lastRender = null;
  }

  // ---- human handoff: post to the theme's native contact form (free) ----
  function submitRep(f, q) {
    var data = new FormData(f);
    data.append('form_type', 'contact');
    data.append('utf8', '✓');
    var action = (CFG.contactAction || '/contact').split('#')[0] || '/contact';
    fetch(action, { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function () { renderSent(q); })
      .catch(function () {
        // last-resort fallback: open the customer's mail client pre-filled
        var name = (f.querySelector('[name="contact[name]"]') || {}).value || '';
        var subject = encodeURIComponent('Help Center question');
        var body = encodeURIComponent((name ? name + '\n\n' : '') + q);
        window.location.href = 'mailto:' + CFG.email + '?subject=' + subject + '&body=' + body;
      });
  }

  // ---- INSTANT answer (no API) from one or more KB entries ----
  function instantAnswer(q, ids) {
    var valid = (ids || []).filter(function (i) { return KB[i]; });
    if (!valid.length) return false;
    renderAnswer(q, valid.map(function (i) { return KB[i].html; }).join(''), valid, 'Common question · instant answer');
    return true;
  }

  // exact / very-close match of a free-typed question to a KB question
  function matchKB(q) {
    var nq = norm(q);
    if (!nq) return -1;
    for (var i = 0; i < KB.length; i++) { if (norm(KB[i].q) === nq) return i; }
    // contained either way (e.g. "do you offer returns" vs "returns")
    for (var j = 0; j < KB.length; j++) {
      var nk = norm(KB[j].q);
      if (nk && (nk.indexOf(nq) !== -1 || nq.indexOf(nk) !== -1) && nq.length > 8) return j;
    }
    return -1;
  }

  // ---- AI answer via the proxy endpoint ----
  function aiAnswer(q) {
    renderThinking(q);

    var kbForModel = KB.map(function (k) { return { id: k.id, q: k.q, a: k.a }; });

    if (!CFG.enabled || !CFG.endpoint) { return localFallback(q); }

    fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: q, kb: kbForModel })
    })
      .then(function (r) { if (!r.ok) throw new Error('bad status ' + r.status); return r.json(); })
      .then(function (data) {
        if (data && data.canAnswer && data.answer) {
          renderAnswer(q, fmt(data.answer), data.sources || []);
        } else {
          renderHandoff(q);
        }
      })
      .catch(function () { localFallback(q); });
  }

  // ---- keyword fallback (no endpoint, or network failed) ----
  function localFallback(q) {
    var words = norm(q).split(' ').filter(function (w) { return w.length > 3; });
    var scored = KB.map(function (k) {
      var hay = (k.q + ' ' + k.a).toLowerCase();
      var score = words.reduce(function (n, w) { return n + (hay.indexOf(w) !== -1 ? 1 : 0); }, 0);
      return { k: k, score: score };
    }).filter(function (s) { return s.score > 0; }).sort(function (a, b) { return b.score - a.score; });
    if (!scored.length) { return renderHandoff(q); }
    var top = scored.slice(0, 2);
    renderAnswer(q, top.map(function (s) { return s.k.html; }).join(''),
      top.map(function (s) { return s.k.id; }), 'Answered from our Help Center');
  }

  // ---- click handling inside the AI card ----
  ai.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-jump]');
    if (jump) {
      var id = +jump.getAttribute('data-jump');
      var item = KB[id] && KB[id].el;
      if (item) {
        item.hidden = false; item.open = true;
        var y = item.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      return;
    }
    if (e.target.closest('[data-rep]')) { renderRepForm(currentQ); return; }
    if (e.target.closest('[data-cancel]')) { if (lastRender) { lastRender(); } else { ai.hidden = true; } return; }
  });

  // ---- submit a typed question ----
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = (input.value || '').trim();
    if (!q) { input.focus(); return; }
    currentQ = q;
    // When the AI endpoint is configured, the FAQ Knowledge Base Sheet (via the
    // Worker) is the single source of truth — route the question there instead
    // of answering from the on-page accordion. On-page keyword matching stays
    // as the offline path (no endpoint / network down).
    if (CFG.enabled && CFG.endpoint) { aiAnswer(q); return; }
    var hit = matchKB(q);
    if (hit !== -1) { instantAnswer(q, [hit]); return; } // no API needed
    aiAnswer(q);
  });

  // ---- popular chips: instant common answers (or submit to AI) ----
  if (pop) {
    pop.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fq-ask]');
      if (!b) return;
      var q = b.getAttribute('data-fq-ask');
      currentQ = q;
      if (input) { input.value = ''; }
      // Endpoint configured → the Sheet is the source of truth; always ask the
      // Worker so a popular chip answers from the Sheet, not the on-page copy.
      if (CFG.enabled && CFG.endpoint) { aiAnswer(q); return; }
      var idsAttr = b.getAttribute('data-fq-ids');
      if (idsAttr) {
        var ids = idsAttr.split(',').map(function (s) { return +s; }).filter(function (n) { return !isNaN(n); });
        if (instantAnswer(q, ids)) return;
      }
      aiAnswer(q);
    });
  }

  // ---- clear (×) button ----
  if (input && clearBtn) {
    input.addEventListener('input', function () { clearBtn.classList.toggle('show', !!input.value.trim()); });
    clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.classList.remove('show'); ai.hidden = true; input.focus(); });
  }
})();
